var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({minWidth: '180px'})},[_c('Datepicker',{attrs:{"value":_vm.value,"day-names":_vm.dayNames,"month-names":_vm.monthNames,"date-formatter":_vm.dateFormatter,"icon":"calendar","position":"is-top-right"},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }